import style from "./ChangingPassword.module.scss";
import { Button, Input } from "@ui";
import { IProxy } from "@interfaces/user/proxy";
import { useUpdatePasswordProxyMutation, useUpdateTimeChangeIpAddressMutation } from "@RTKQuery/user/purchases/purchases";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";

export function ChangingPassword({
    data
}: {
    data: IProxy
}) {
    const { activePaginationLimit, activePaginationPage, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage)

    const [updatePasswordProxy, { isSuccess, isLoading, reset, error }] = useUpdatePasswordProxyMutation();

    const [inputValue, setInputValue] = useState<string>("")

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (isSuccess) {
            setInputValue("")
            timer = setTimeout(() => {
                reset();
            }, 2500)
        }

        return () => {
            clearTimeout(timer)
        }
    }, [isSuccess])

    return (
        <div className={style.container}>
            <p className="text-center text-[#1B1B1D] text-[16px] font-semibold leading-normal mb-[10px]">Редагування паролю</p>
            <p className="text-center text-[#1B1B1D] text-[13px] font-normal mb-[30px] max-sm:mb-[20px]">Ваш пароль: <span className="font-semibold">{data.proxy_password}</span></p>
            <Input
                value={String(inputValue)}
                onChange={(value) => {
                    setInputValue(value)
                }}
                label="Введіть нове значення"
                customStyle={{
                    width: "!w-[300px] !max-w-[300px] !mx-auto !mb-[30px]"
                }}
            />
            <Button
                tabIndex={-1}
                text={
                    isSuccess
                        ? "Успішно збережено"
                        : "Зберегти"
                }
                color="blue"
                customStyle={{
                    button: "!w-[180px] !h-[38px] ",
                    width: "!mx-auto"
                }}
                loading={isLoading}
                errors={[
                    (error && ((extractError) => {
                        return extractError(error)
                    }))
                ]}
                onClick={() => {
                    updatePasswordProxy({
                        purchase_id: data.id,
                        password: inputValue,
                        params: {
                            limit: activePaginationLimit,
                            page: activePaginationPage,
                            search: activeSearchParameter,
                            tag_ids: activeTags
                        },
                    });
                }}
                resetStatus={() => {
                    reset();
                }}
            />
        </div>
    )
}